import { render, staticRenderFns } from "./TheStorageSetup.vue?vue&type=template&id=13912124&"
import script from "./TheStorageSetup.vue?vue&type=script&lang=js&"
export * from "./TheStorageSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports